<template>
    <v-btn v-bind="props" color="error" class="button_error">
        <slot></slot>
    </v-btn>
</template>

<script>
export default {
  name: 'ButtonError',
  props: {
    props: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss">
@use '@/styles/_index' as *;


    .button_error{
        text-transform: inherit;
        height: 40px;
        padding: 0 19px;
        background-color: $dangerColor;
    }
</style>
